export default __webpack_public_path__ + "static/media/checkgray_Icon.b78cb97b.svg";